export const STATUSES_IN = {
  ApplicationForMembership: 'ApplicationForMembership',
  ApplicationForMembershipRejected: 'ApplicationForMembershipRejected',
  Chief: 'Chief',
  Expelled: 'Expelled'
}
